module.exports = __webpack_public_path__ + "img/Expo_Topic2.530d69ca.png";